import { dsColorNew } from "@palette";
import { alpha } from "@mui/material/styles"

export const MaximalLayoutNavMiniItemStyles = (isActive, isSubItem, theme) => ({
    flexDirection: 'column',
    padding: theme.spacing(1, 0, 0.5, 0),
    color: alpha(dsColorNew.white, 0.82),
    borderRadius: theme.shape.borderRadius * 0.2,
    '&:hover': {
        backgroundColor: alpha(dsColorNew.white, 0.06),
        color: alpha(dsColorNew.white, 0.85),
    },
    ...( isSubItem && {
        padding: theme.spacing(1)
    } ),
    ...( isActive && {
        color: dsColorNew.white,
        backgroundColor: dsColorNew.appBlue,
        '&:hover': {
            color: dsColorNew.white,
            backgroundColor: dsColorNew.appBlueHover,
        },
        i: {
            color: dsColorNew.white
        }
    })
})

export const MaximalLayoutNavMiniIconStyles = ({
    marginRight: 0,
    marginBottom: "4px",
    width: "22px",
    height: "22px",
    minWidth: 'auto',
    color: 'inherit'
})

export const MaximalLayoutNavMiniArrow = ({
    fontSize: 10,
    position: 'absolute',
    right: "4px",
    top: "11px"
})